module.exports = __webpack_public_path__ + "static/media/Mulish-Black.5dc89e96.woff";